import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 50px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const HeaderLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  flex: 1 1 auto;
`;

export const TypographyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 16px;
`;

export const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  min-width: 150px;
  flex: 0 0 auto;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

